module.exports = __webpack_public_path__ + "static/img/1.5e71473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/bg/1.jpg
// module id = tFcU
// module chunks = 0